import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  iconsContainer: {
    display: 'flex',
    alignItems: 'center',
  },  
  invalidCodeMessage: {
    textAlign: "center", 
    fontSize: 21, 
    marginTop: 16,
    marginBottom: 16
  },  
  resendCode: {
    textAlign: "center", 
    fontSize: 18, 
    marginBottom: 16
  },

  confirmPaymentBtnContainer: {
    margin: 16,
    width: '90%',
    marginTop: 20,
    alignSelf: 'center',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: {
        width: 0,
        height: 5,
    },
    shadowOpacity: 0.34,
    shadowRadius: 6.27,
},
confirmPaymentBtn: {
    height: 67,
},
confirmPaymentBtnText: {
    fontSize: 18,
},
});

export default styles;